import { useState } from "react";
import { Navigate, useOutletContext } from "react-router-dom";
import { PraxisSettings } from "./settings/PraxisSettings";
import { UserSettings } from "./settings/UserSettings";
import { ReferrerList } from "./settings/ReferrerList";
import { AuditLogView } from "./settings/AuditLogView";
import { PruefSettings } from "./settings/PruefSettings";
import { DsgvoSettings } from "./settings/DsgvoSettings";

const TABS: [string, string][] = [["praxis", "Praxis"], ["benutzer", "Benutzer"], ["ueberweiser", "Überweiser"], ["pruefung", "Prüfung & Testmodus"], ["datenschutz", "Datenschutz"], ["audit", "Audit-Log"]];

export default function Settings() {
  const me: any = useOutletContext();
  const [tab, setTab] = useState("praxis");
  if (me.benutzer.rolle !== "ADMIN") return <Navigate to="/praxis/faelle" replace />;
  return (
    <div className="kd-fade">
      <h1 className="mb-5">Einstellungen</h1>
      <div className="mb-5 flex gap-1 overflow-x-auto border-b border-border" role="tablist">
        {TABS.map(([k, l]) => (
          <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`settings-tab-${k}`}
            className={`min-h-[44px] whitespace-nowrap border-b-2 px-4 font-medium transition-colors ${tab === k ? "border-primary text-primary" : "border-transparent text-text-muted hover:text-text"}`}>{l}</button>
        ))}
      </div>
      {tab === "praxis" && <PraxisSettings />}
      {tab === "benutzer" && <UserSettings meId={me.benutzer.id} />}
      {tab === "ueberweiser" && <ReferrerList />}
      {tab === "pruefung" && <PruefSettings />}
      {tab === "datenschutz" && <DsgvoSettings />}
      {tab === "audit" && <AuditLogView />}
    </div>
  );
}
